import { $GQL } from '@GQL';
import type { User } from '@nextgenleads/auth-driver';

export async function setInitialUserPassword(id: string, password: string): Promise<User> {
	const mutation = `
        mutation SetInitialUserPassword($id: ID!, $password: String!) {
            setInitialUserPassword(id: $id, password: $password) {
				id
			}
        }
    `;

	const result = await $GQL.request(mutation, { id, password });
	return result.setInitialUserPassword;
}
